import { HTTPError } from 'ky'
import { guest } from '#shared/lib/user/guest'
import { type GetCurrentUserResponse } from '#shared/model/get-current-user-response'
import { httpClient } from './http-client'

export async function getCurrentUser() {
  try {
    const response = await httpClient.get<GetCurrentUserResponse>('users/me', { requireAuth: true })
    const responseBody = await response.json()
    return responseBody.data
  } catch (error: unknown) {
    if (error instanceof HTTPError && error.response.status === 401) {
      return guest
    }

    throw error
  }
}
